import React, { useEffect } from 'react';
import Portal from '../Portal';

interface SubscriptionSuccessModalProps {
  onClose: () => void;
}

export function SubscriptionSuccessModal({
  onClose,
}: SubscriptionSuccessModalProps) {
  // Lock body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const handleGetStarted = () => {
    // Redirect to /my-collection and refresh
    window.location.href = '/my-collection';
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <Portal>
      <div 
        className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[9999] flex items-center justify-center p-4"
        onClick={handleBackdropClick}
      >
        <div className="bg-bg border border-white/20 rounded-xl p-6 sm:p-8 w-full max-w-md shadow-lg">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-white text-center">You Have Successfully Subscribed!</h2>
          </div>

          <div className="mb-8">
            <p className="text-white/90 text-lg text-center">
              You have unlocked full access to GenAnything. What are you waiting for?
            </p>
          </div>

          <button
            onClick={handleGetStarted}
            className="w-full bg-[#F9F7EA] text-[#0f1218] px-6 py-3 min-h-[48px] rounded-full text-base font-semibold hover:bg-[#E7D7B1] transition-colors"
          >
            Get Started
          </button>
        </div>
      </div>
    </Portal>
  );
}

